import { render, staticRenderFns } from "./config-role.vue?vue&type=template&id=749edfb6&scoped=true&"
import script from "./config-role.vue?vue&type=script&lang=js&"
export * from "./config-role.vue?vue&type=script&lang=js&"
import style0 from "./config-role.vue?vue&type=style&index=0&id=749edfb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749edfb6",
  null
  
)

export default component.exports